import { Flex, FlexProps } from "@chakra-ui/react";
import * as React from "react";

interface AppShellProps extends FlexProps {
  children: React.ReactNode;
}

export default function AppShell({ children, ...props }: AppShellProps) {
  return (
    <Flex height="full" flex="1" {...props}>
      {children}
    </Flex>
  );
}
